import React from 'react';
import { ValidationError } from '../../apps/benefit/models/Errors';
import Checkbox, { CheckboxProps } from './Checkbox';
import ErrorViewer from './ErrorViewer';
import Icons from './Icons';
import PopoverDialog from './PopoverDialog';

interface CheckboxGroupProps {
  label?: string;
  checkboxes: CheckboxProps[];
  info?: string;
  helper?: string;
  errors?: ValidationError[];
  mandatory?: boolean;
  controlClassName?: string;
}

export const CheckboxGroup = (props: CheckboxGroupProps) => {
  const {
    label,
    checkboxes,
    mandatory,
    helper,
    info,
    errors,
    controlClassName,
  } = props;

  const mandatoryElement = mandatory ? `<sup>*</sup>` : '';
  const classNames = `checkboxes-list ${controlClassName ?? ''}`.trim();
  return (
    <>
      {React.isValidElement(label) ? (
        label
      ) : (
        <label
          className="k-checkbox-label"
          dangerouslySetInnerHTML={{
            __html: label ? `${label}${mandatoryElement}` : '<span></span>',
          }}
        />
      )}
      {!!info && (
        <PopoverDialog
          placement="bottom"
          appendTo={document.body}
          type="click"
          content={info}
        >
          <div>
            <Icons.Info />
          </div>
        </PopoverDialog>
      )}
      {!!helper && <div className="control-info">{helper}</div>}
      {checkboxes.map(e => (
        <div key={e.label} className={classNames}>
          <Checkbox {...e} />
        </div>
      ))}
      <ErrorViewer errors={errors} />
    </>
  );
};
